import React from 'react';
import { BsTwitter } from 'react-icons/bs';
import {FaGithub} from 'react-icons/fa';
import { BiLogoLinkedin } from "react-icons/bi";


const SocialMedia = () => (
  <div className="app__social">
    <div>
      <a href="https://twitter.com/ThakurSameeksh" target='blank'>
        <BsTwitter />
      </a>
    </div>
    <div>
      <a href="https://linkedin.com/in/sameeksh-thakur" target='blank'>
        <BiLogoLinkedin />
      </a>
    </div>
    <div>
      <a href="https://github.com/SameekshThakur" target='blank'>
        <FaGithub />
      </a>
      
    </div>
  </div>
);

export default SocialMedia;
